import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

// ── Change this to localhost for testing ──
const API = 'https://fx.fxcapitalindia.in/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  // Check stored token on startup
  useEffect(() => {
    const token  = localStorage.getItem('fx_token');
    const userId = localStorage.getItem('fx_userid');
    if (token) {
      axios.get(API + '/users/verify', {
        headers: { Authorization: 'Bearer ' + token }
      })
      .then(res => {
        setUser({
          token,
          userId:          userId,
          fullName:        res.data.fullName,
          isAdmin:         res.data.isAdmin,
          isApproved:      res.data.isApproved,
          alertsAccess:    res.data.alertsAccess,
          billingAccess:   res.data.billingAccess,
          ratePermissions: res.data.ratePermissions,
        });
      })
      .catch(() => {
        localStorage.removeItem('fx_token');
        localStorage.removeItem('fx_userid');
      })
      .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  // ── Email + Password Login ──
  const login = async (email, password) => {
    const res = await axios.post(API + '/users/login', { email, password });
    if (res.data.success) {
      localStorage.setItem('fx_token',  res.data.token);
      localStorage.setItem('fx_userid', res.data.id);
      setUser({
        token:           res.data.token,
        userId:          res.data.id,
        fullName:        res.data.fullName,
        isAdmin:         res.data.isAdmin,
        isApproved:      res.data.isApproved,
        alertsAccess:    res.data.alertsAccess,
        billingAccess:   res.data.billingAccess,
        ratePermissions: res.data.ratePermissions,
      });
      return { success: true };
    }
    return { success: false, message: res.data.message };
  };

  // ── Google Login — called after Google returns token ──
  const loginWithToken = (data) => {
    localStorage.setItem('fx_token',  data.token);
    localStorage.setItem('fx_userid', data.id);
    setUser({
      token:           data.token,
      userId:          data.id,
      fullName:        data.fullName,
      isAdmin:         data.isAdmin,
      isApproved:      data.isApproved,
      alertsAccess:    data.alertsAccess,
      billingAccess:   data.billingAccess,
      ratePermissions: data.ratePermissions,
    });
  };

  // ── Logout ──
  const logout = async () => {
    const token = localStorage.getItem('fx_token');
    if (token) {
      try {
        await axios.post(API + '/users/logout', {}, {
          headers: { Authorization: 'Bearer ' + token }
        });
      } catch (e) {}
    }
    localStorage.removeItem('fx_token');
    localStorage.removeItem('fx_userid');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{
      user,
      loading,
      login,
      loginWithToken,
      logout,
      API,
      token:         user?.token         || '',
      userId:        user?.userId        || '',
      isApproved:    user?.isApproved    || false,
      alertsAccess:  user?.alertsAccess  || false,
      billingAccess: user?.billingAccess || false,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}